import React, { useState } from 'react';

/* ------------------------------ Switch ------------------------------ */

type SwitchProps = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
};

const SwitchInput: React.FC<SwitchProps> = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  className = '',
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const toggle = () => {
    if (disabled) return;
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };

  return (
    <label
      className={`group flex items-center justify-between gap-3 cursor-pointer select-none ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
    >
      {label && <span className='text-sm font-medium text-gray-700 dark:text-gray-200 group-hover:text-gray-900 dark:group-hover:text-white transition-colors'>{label}</span>}
      <button
        type='button'
        onClick={toggle}
        role='switch'
        aria-checked={isChecked}
        disabled={disabled}
        className={`
          relative w-11 h-6 flex items-center rounded-full p-1 transition-all duration-300 outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900
          ${isChecked ? 'bg-primary-600 hover:bg-primary-700' : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600'}
        `}
      >
        <span
          className={`
            bg-white w-4 h-4 rounded-full shadow-sm transform transition-transform duration-300
            ${isChecked ? 'translate-x-5' : 'translate-x-0'}
          `}
        />
      </button>
    </label>
  );
};

export default SwitchInput;

/* ---------------------------- Example Usage ----------------------------

<Switch label="Enable notifications" />

<Switch
  label="Dark mode"
  checked={true}
  onChange={(checked) => console.log('Dark mode:', checked)}
/>

*/
